<div class="row" *ngIf="form && selectedDeliveryLocation">
  <!--<div class="col-12">
    <div class="form-group">
      <label for="deliveryLocation" class="control-label" translate>RETURN_LOCATION</label>
      <select name="deliveryLocation" id="deliveryLocation" class="form-control form-select" [(ngModel)]="deliveryLocationId">
        <option [value]="option.id" *ngFor="let option of deliveryLocations; let first = first">
          {{ first ? ('CUSTOMER_ADDRESS' | translate) : option.name }}
        </option>
      </select>
    </div>
  </div>-->

  <div class="col-12 col-md-6">
    <fieldset [disabled]="true">
      <div class="form-group" [formGroup]="form">
        <label for="ordlevadr1" class="control-label" translate>RETURN_SENDER</label>
        <input class="form-control" type="text" name="ordlevadr1" id="ordlevadr1" [formControlName]="'ordlevadr1'" />
      </div>
      <div class="form-group" [formGroup]="form">
        <label for="ordlevadr2" class="control-label" translate>OH_ORDLEVADR2</label>
        <input class="form-control" type="text" name="ordlevadr2" id="ordlevadr2" [formControlName]="'ordlevadr2'" />
      </div>
      <div class="form-group" [formGroup]="form">
        <label for="ordlevadr3" class="control-label" translate>RETURN_PICKUP_ADDRESS</label>
        <input class="form-control" type="text" name="ordlevadr3" id="ordlevadr3" [formControlName]="'ordlevadr3'" />
      </div>
      <div class="form-group">
        <label for="postalCode" class="control-label" translate>OH_FTGPOSTNR</label>
        <input class="form-control" type="text" name="postalCode" id="postalCode" [(ngModel)]="postalCode" />
      </div>
      <div class="form-group">
        <label for="city" class="control-label" translate>OH_ORDLEVADR4</label>
        <input class="form-control" type="text" name="city" id="city" [(ngModel)]="city" />
      </div>
      <div [formGroup]="form">
        <lib-meta-select-input formControlName="ordlevadrlandskod" table="xr" metaId="landskod" metaDisplay="land">
        </lib-meta-select-input>
      </div>
    </fieldset>
  </div>
  <div class="col-12 col-md-6">
    <div class="form-group" [formGroup]="formOh">
      <label for="kundbestnr" class="control-label" translate>OH_KUNDBESTNR</label>
      <input readonly class="form-control" type="text" name="kundbestnr" id="kundbestnr" formControlName="kundbestnr" />
    </div>
    <div class="form-group" [formGroup]="formOh">
      <label for="kundref2" class="control-label" translate>OH_KUNDREF2</label>
      <input class="form-control" type="text" name="kundref2" id="kundref2" formControlName="kundref2" />
    </div>
    <div
      *ngIf="formOh.get('kundref2').invalid && (formOh.get('kundref2').dirty || formOh.get('kundref2').touched)"
      class="alert alert-danger"
    >
      <span translate>FORM_ERROR_REQUIRED</span>
    </div>
    <div class="form-group" [formGroup]="formReturn">
      <label for="phone" class="control-label" translate>PHONE</label>
      <input class="form-control" type="text" name="phone" id="phone" formControlName="phone" />
    </div>
    <div
      *ngIf="formReturn.get('phone').invalid && (formReturn.get('phone').dirty || formReturn.get('phone').touched)"
      class="alert alert-danger"
    >
      <span translate>FORM_ERROR_REQUIRED</span>
    </div>
    <lib-confirmation-emails
      [emails]="checkout.extra.confirmationEmails"
      (emailsUpdated)="checkout.extra.confirmationEmails = $event"
    ></lib-confirmation-emails>
  </div>
  <hr />
  <!-- RETURNS: -->
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <h4 translate>RETURN_INFORMATION</h4>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group" [formGroup]="formReturn">
              <label for="ordreturservice" class="control-label" translate>RETURN_SERVICE_TYPE</label>
              <select
                name="ordreturservice"
                id="ordreturservice"
                class="form-control"
                [formControlName]="'ordreturservice'"
                (change)="onOrdreturserviceChange($event)"
              >
                <option [value]="service.id" *ngFor="let service of returnServices">
                  {{ service.name }} ({{ service.id }})
                </option>
              </select>
            </div>
            <div
              *ngIf="
                formReturn.get('ordreturservice').invalid &&
                (formReturn.get('ordreturservice').dirty || formReturn.get('ordreturservice').touched)
              "
              class="alert alert-danger"
            >
              <span translate>FORM_ERROR_REQUIRED</span>
            </div>

            <div class="form-group" [formGroup]="formReturn">
              <lib-delivery-date-picker
                label="UNIFAUN_PICKUP_DATE"
                [initialDate]="checkout.extra.unifaunReturn.ordreturdatum"
                [minInitialDate]="minReturnDate"
                (selectedDate)="dateSelected($event)"
              >
              </lib-delivery-date-picker>
            </div>
            <div
              *ngIf="
                formReturn.get('ordreturdatum').invalid &&
                (formReturn.get('ordreturdatum').dirty || formReturn.get('ordreturdatum').touched)
              "
              class="alert alert-danger"
            >
              <span translate>FORM_ERROR_REQUIRED</span>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group" [formGroup]="formReturn">
              <label for="ordreturinstruktioner" class="control-label" translate>PICKUP_INSTRUCTIONS</label>
              <textarea
                class="form-control"
                type="text"
                name="ordreturinstruktioner"
                rows="5"
                id="ordreturinstruktioner"
                [formControlName]="'ordreturinstruktioner'"
                maxlength="70"
              ></textarea>
            </div>
            <div
              *ngIf="
                formReturn.get('ordreturinstruktioner').invalid &&
                (formReturn.get('ordreturinstruktioner').dirty || formReturn.get('ordreturinstruktioner').touched)
              "
              class="alert alert-danger"
            >
              <span translate>FORM_ERROR_REQUIRED</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <h5 translate>UNIFAUN_RETURN_ROWS_HELPER_TEXT</h5>
        <div *ngFor="let row of packagingRows; let i = index" class="row border mt-1 mb-1 pt-1">
          <div class="col-12">
            <span translate>PARCEL</span> {{ i + 1 }}
            <button class="btn btn-sm btn-warning float-right" (click)="removePackagingRow(i)">
              <i class="fas fa-minus"></i>
            </button>
          </div>
          <div class="form-group col-4">
            <label for="amount" class="control-label" translate> COUNT </label>
            <input
              class="form-control"
              disabled="disabled"
              type="number"
              [(ngModel)]="row.amount"
              name="amount"
              id="amount"
              min="1"
              step="1"
            />
          </div>
          <div class="form-group col-4">
            <label for="parcelType" class="control-label" translate> PARCEL_TYPE </label>
            <select name="parcelType" id="parcelType" class="form-control form-select" [(ngModel)]="row.parcelType">
              <option [value]="option.id" *ngFor="let option of parcelTypes">
                {{ option.name }} ({{ option.id }})
              </option>
            </select>
          </div>
          <div class="form-group col-4">
            <label for="weight" class="control-label"> <span translate>WEIGHT</span> (kg) </label>
            <input
              class="form-control"
              type="number"
              [(ngModel)]="row.weight"
              name="weight"
              id="weight"
              min="0"
              max="150"
              step="0.01"
            />
          </div>
          <!--<div class="form-group col-4">
            <label for="length" class="control-label"> <span translate>LENGTH</span> (cm) </label>
            <input
              class="form-control"
              type="number"
              [(ngModel)]="row.length"
              name="length"
              id="length"
              min="0"
              step="1"
            />
          </div>
          <div class="form-group col-4">
            <label for="width" class="control-label"> <span translate>WIDTH</span> (cm) </label>
            <input
              class="form-control"
              type="number"
              [(ngModel)]="row.width"
              name="width"
              id="width"
              min="0"
              step="1"
            />
          </div>
          <div class="form-group col-4">
            <label for="height" class="control-label"> <span translate>HEIGHT</span> (cm) </label>
            <input
              class="form-control"
              type="number"
              [(ngModel)]="row.height"
              name="height"
              id="height"
              min="0"
              step="1"
            />
          </div>-->
          <div class="form-group col-4">
            <label for="articleType" class="control-label" translate> UNIFAUN_ARTICLE_TYPE </label>
            <input
              class="form-control"
              type="text"
              [(ngModel)]="row.articleType"
              name="articleType"
              id="articleType"
              maxlength="70"
            />
          </div>
        </div>
        <div *ngIf="this?.checkout?.extra?.unifaunReturn?.packagingRows?.length === 0" class="alert alert-danger">
          <span translate>FORM_ERROR_REQUIRED</span>
        </div>

        <div class="col-12">
          <button class="btn btn-sm btn-primary" (click)="addPackagingRow()">
            <i class="fas fa-plus"></i>
          </button>
          <span class="ml-2" translate>ADD_PACKAGING_ROW</span>
        </div>
      </div>
    </div>
  </div>
</div>
